/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createLog10 } from '../../factoriesNumber.js';
export var log10Dependencies = {
  typedDependencies,
  createLog10
};